// extracted by mini-css-extract-plugin
var _1 = "styles-module__photoItem___SIGsS";
var _2 = "styles-module__photoItemDynamic___lKbnp";
export { _1 as "photoItem", _2 as "photoItemDynamic" }
